import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Force cache clear for deployment sync
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
  
  // Clear all caches
  if ('caches' in window) {
    caches.keys().then(function(names) {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}

// Attach admin session to all /api calls after login (required since security remediation)
const _nativeFetch = window.fetch.bind(window);
window.fetch = function (input, init = {}) {
  try {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.startsWith('/api/') || (typeof window !== 'undefined' && url.includes(`${window.location.origin}/api/`));
    const isLogin = url.includes('/api/admin/login');
    const token = localStorage.getItem('sessionToken');
    if (isApi && !isLogin && token) {
      const headers = new Headers(init.headers || {});
      if (!headers.has('X-Admin-Session')) {
        headers.set('X-Admin-Session', token);
      }
      init = { ...init, headers };
    }
  } catch (_) { /* ignore localStorage errors */ }
  return _nativeFetch(input, init);
};

// Build-time id (set REACT_APP_DEPLOYMENT_VERSION when running `npm run build` / deploy scripts)
window.DEPLOYMENT_VERSION = import.meta.env.REACT_APP_DEPLOYMENT_VERSION || 'local-dev';
console.log('🚀 Deployment Version:', window.DEPLOYMENT_VERSION);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Disable service worker for now to prevent caching issues
// serviceWorkerRegistration.unregister();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
